import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, ButtonGroup, Popover, Menu, MenuItem, MenuDivider, Divider } from '@blueprintjs/core';
import { ButtonCopy } from '@moleculeone/ui';

import cls from './ContextToolbox.module.css';

const MOL_CONTAINER_PADDING = 90;

function ContextToolbox({
  moleculeId,
  bbox,
  scale,
  onOpen,
  onClose,
  onDetailsClick,
  onSaveCompound,
  onExportCompound,
  onCopySmiles,
  getSmilesById,
  onNewSearchFromHere,
  onRedraw,
  selected,
  onlyCopySmilesOptionVisible = false,
}) {
  return (
    <foreignObject
      x={bbox.min[0] - MOL_CONTAINER_PADDING / scale}
      y={bbox.min[1] - 30 - MOL_CONTAINER_PADDING / scale}
      width={(bbox.size[0] + MOL_CONTAINER_PADDING * 2) / scale}
      height={(bbox.size[1] + MOL_CONTAINER_PADDING * 2) / scale}
      style={{
        transform: `scale(${scale}, ${scale})`,
        transformOrigin: `${bbox.min[0]}px ${bbox.min[1]}px`,
      }}
    >
      <div
        className={cx(cls.molControls, {
          [cls.molControlsVisible]: selected,
        })}
        style={{
          left: 'auto',
          top: MOL_CONTAINER_PADDING / 3 / scale,
          right: MOL_CONTAINER_PADDING / 3 / scale,
          bottom: 'auto',
        }}
      >
        {onlyCopySmilesOptionVisible ? (
          <ButtonCopy
            copy={getSmilesById(moleculeId)}
            tooltipText="Copy SMILES to clipboard"
            weight="minimal"
            size="small"
          />
        ) : (
          <ButtonGroup onClick={e => e.stopPropagation()}>
            <Button icon="data-lineage" title="Details" small minimal onClick={() => onDetailsClick(moleculeId)} />
            <Popover onClosed={() => onClose()} onOpening={() => onOpen(moleculeId)} hasBackdrop captureDismiss>
              <Button icon="more" title="Actions" small minimal />
              <Menu>
                <MenuDivider title="Compound" />
                <Divider />
                <MenuItem onClick={() => onNewSearchFromHere(moleculeId)} text="New search from here" />
                <MenuItem onClick={() => onExportCompound(moleculeId)} text="Export MDL" />
                <MenuItem onClick={() => onSaveCompound(moleculeId)} text="Save compound" />
                <MenuItem onClick={() => onCopySmiles(moleculeId)} text="Copy SMILES" />
                <MenuItem onClick={() => onRedraw(moleculeId)} text="Redraw" />
              </Menu>
            </Popover>
          </ButtonGroup>
        )}
      </div>
    </foreignObject>
  );
}

ContextToolbox.propTypes = {
  moleculeId: PropTypes.number,
  bbox: PropTypes.object,
  scale: PropTypes.number,
  selected: PropTypes.bool,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDetailsClick: PropTypes.func,
  onlyCopySmilesOptionVisible: PropTypes.bool,
};

export default ContextToolbox;
